<template>
    <div class="content">
        <div class="contentVVV">
            <div v-html="text"></div>
        </div>
    </div>
</template>

<script>
export default {
    mixins: [],
    components: {
    },
    data() {
        return {
            text: '',
            type: 0,
        };
    },
    created() {
    },
    mounted() {
        // 0用户协议、1隐私协议
        this.type = this.$route.query.type;
        if (Number(this.type) == 0) {
            this.getUserAgreementApi();
        } else {
            this.getPrivacyApi();
        }

    },
    methods: {
        // 用户协议
        async getUserAgreementApi() {
            try {
                const res = await this.$get('system/content/getUserAgreement');
                this.text = res.data.content
            } catch (error) {
            }
        },
        // 隐私协议
        async getPrivacyApi() {
            try {
                const res = await this.$get('system/content/getPrivacy');
                this.text = res.data.content
            } catch (error) {
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    height: 100%;

    .contentVVV {
        padding: 40px 40px;
    }

    .divA {
        margin-top: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .divA1 {
            margin-left: 110px;
            width: 127px;
            height: 35px;
        }

        .divA2 {
            margin-right: 91px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .divA21 {
                font-size: 24px;
                font-family: Poppins, Poppins-700;
                font-weight: 700;
                color: #12181d;
            }

            .divA22 {
                margin-top: 8px;
                width: 108px;
                height: 20px;
            }
        }
    }

    .divB {
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url('../assets/images2/2.png');
        background-size: 100% 100%;
        background-position: center center;
        width: 100%;
        height: 627px;

        .formV {
            width: 580px;
            height: 482px;
            background: #f7f8fa;
            border-radius: 16px;

            .formVV {
                margin: 32px 32px;
                display: flex;
                flex-direction: column;
                align-items: center;

                .btn {
                    margin-top: 24px;
                    font-size: 14px;
                    font-family: Inter, Inter-400;
                    font-weight: 400;
                    color: #ffffff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 57px;
                    background: #f624d5 linear-gradient(90deg, #f624d5, #3437f7 100%);
                    border-radius: 8px;
                }

                .name {
                    // margin-top: 24px;
                    font-size: 56px;
                    font-family: Poppins, Poppins-700;
                    font-weight: 700;
                    color: #12181d;
                }

                .t {
                    margin-top: 15px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .t1 {
                        font-size: 16px;
                        font-family: PingFang SC, PingFang SC-400;
                        font-weight: 400;
                        color: #12181d;
                    }

                    .t2 {
                        margin-left: 8px;
                        font-size: 16px;
                        font-family: PingFang SC, PingFang SC-400;
                        font-weight: 400;
                        color: #fa14d5;
                    }
                }

                .valueA {
                    width: 100%;
                    margin-top: 32px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 53px;
                    background: #ffffff;
                    border-radius: 8px;
                }

                .valueB {
                    width: 100%;
                    margin-top: 24px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 53px;
                    background: #ffffff;
                    border-radius: 8px;
                }

                .Forgot {
                    margin-top: 16px;
                    font-size: 14px;
                    font-family: Poppins, Poppins-400;
                    font-weight: 400;
                    color: #12181d;
                }

                .checkboxV {
                    margin-top: 32px;
                    width: 100%;
                    display: flex;
                    align-items: center;

                    .checkImg {
                        width: 12px;
                        height: 12px;
                    }

                    .checkName {
                        margin-left: 5px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 12px;
                        font-family: Poppins, Poppins-400;
                        font-weight: 400;
                        color: #3f5566;

                        .checkName1 {
                            margin: 0 5px;
                            font-size: 12px;
                            font-family: Poppins, Poppins-400;
                            font-weight: 400;
                            color: #FA14D5;
                        }
                    }
                }
            }
        }
    }

    .divC {
        margin-bottom: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .divC1 {
            margin-left: 110px;
            width: 28px;
            height: 4px;
        }

        .divC2 {
            margin-right: 91px;
            font-size: 16px;
            font-family: Inter, Inter-400;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.60);
        }
    }
}

.Require {
    margin-left: 5px;
    width: 5px;
    height: 4px;
}

::v-deep .el-input__inner {
    border: none !important;
}

::v-deep .el-input__prefix {
    margin-left: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}

::v-deep.el-input--prefix .el-input__inner {
    padding-left: 100px !important;
}
</style>
